export default __webpack_public_path__ + "static/media/US.48ea98b2.svg";